export const BASE_URL = ''
export const POSTS_URL = '/api/posts'
export const GAMES_URL = '/api/games'
export const USERS_URL = '/api/users'
export const TWITCH_URL = '/api/twitch'
export const BOOKMARKS_URL = '/api/bookmarks'
export const LIKES_URL = '/api/likes'
export const POST_COMMENTS_URL = '/api/post-comments'
export const USER_COMMENTS_URL = '/api/user-comments'
export const GAME_COMMENTS_URL = '/api/game-comments'
export const BADGES_URL = '/api/badges'
